import './appointment';
import './login';
import './logout';
import './messages';
import './project';



// WEBPACK FOOTER //
// ./routes/index.js